import React from 'react';
import Table, { TableRow, TableHeading, TableBody, TableCell } from '../../table/Table';

const ResponseTimes = ({ dataset }) => (
  <Table>
    <TableHeading>
      <TableCell as="th" fill strong>
        Day
      </TableCell>
      <TableCell as="th" fill strong>
        Payment Initiation (Dedicated)
      </TableCell>
      <TableCell as="th" fill strong>
        Account information (Dedicated)
      </TableCell>
      <TableCell as="th" fill strong>
        Funds check (Dedicated)
      </TableCell>
      <TableCell as="th" fill strong>
        Payment Initiation (Mobile)
      </TableCell>
      <TableCell as="th" fill strong>
        Account information (Mobile)
      </TableCell>
    </TableHeading>
    <TableBody>
      {dataset.map((item) => (
        <TableRow key={`response_${item.day}`}>
          <TableCell as="th" fill strong>
            {item.day}
          </TableCell>
          <TableCell>{item.partnerPisp}</TableCell>
          <TableCell>{item.partnerAisp}</TableCell>
          <TableCell>{item.cbpii}</TableCell>
          <TableCell>{item.mobilePisp}</TableCell>
          <TableCell>{item.mobileAisp}</TableCell>
        </TableRow>
      ))}
    </TableBody>
  </Table>
);

export default ResponseTimes;
